const lenis = new Lenis({
  inertia: 0.05,
});

lenis.on("scroll", (e) => { });

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

class Utils {
  // 滑动页面
  static pageScroll(position, diff = 0, duration = 1500) {
    if (typeof lenis !== "undefined" && lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(position - diff, {
        duration: duration / 1000,
        easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
      });
    } else {
      jQuery("html,body").animate({ scrollTop: position - diff }, duration);
    }
  }

  // 复制文本到剪贴板
  static copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  }

  // 手风琴初始化
  static accordionInit(toggleEl, targetEl, duration = 300, breakpoint = 99999) {
    jQuery("body").on("click", toggleEl, (e) => {
      if (jQuery(window).width() < breakpoint) {
        jQuery(e.currentTarget).siblings(targetEl).stop().slideToggle(duration);
        jQuery(e.currentTarget).parent().toggleClass("active").siblings().removeClass("active").find(targetEl).slideUp(duration);
      }
    });
  }

  // 携带参数跳转后对元素进行模拟点击
  static clickParamEl(param, selector, elAttr) {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(param);

    const el = jQuery(`${selector}[${elAttr}=${paramValue}]`);

    if (paramValue && el.length) {
      el.click();
    }
  }

  // 防抖
  static debounce(fn, delay, immediate = false) {
    let timer = null;
    let isInvoked = false;

    return function (...args) {
      const context = this;

      clearTimeout(timer);

      if (immediate && !isInvoked) {
        fn.apply(context, args);
        isInvoked = true;

        timer = setTimeout(() => {
          isInvoked = false;
        }, delay);
      } else {
        timer = setTimeout(() => {
          fn.apply(context, args);
          isInvoked = false;
        }, delay);
      }
    };
  }

  // 节流
  static throttle(fn, limit) {
    let lastFunc;
    let lastRan;

    return function (...args) {
      const context = this;
      if (!lastRan) {
        fn.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            fn.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }
}

const customMethods = {
  run: function () {
    this.init();
    this.appHeight();
    this.wowo();
    this.slider();
    this.headerMenu();
    this.anchorLink();
    this.accordion();
    this.parallax();
    this.paramsFun();
    this.hoverEffect();
    this.imgOpenPopup();
    this.loadMore();
    this.formFun();
  },

  // Initialization work
  init: function () {
    jQuery("html").addClass("show-c");
  },

  // Calculate screen height by ignoring the height of the toolbar
  appHeight: function () {
    const doc = document.documentElement;
    doc.style.setProperty("--vh", jQuery(window).innerHeight() * 0.01 + "px");
  },

  // Entry animation
  wowo: function () {
    const _this = this;

    setTimeout(function () {
      let wTop = jQuery(window).scrollTop(),
        wHeight = jQuery(window).height(),
        wBottom = wTop + wHeight;

      jQuery(".wowo:not(.animated)").each(function () {
        let me = jQuery(this),
          meTop = me.offset().top,
          meHeight = me.height(),
          meBottom = meTop + meHeight,
          limitTop = wTop - meHeight,
          limitBottom = wBottom + meHeight;

        if (meTop > limitTop && meBottom < limitBottom) {
          me.addClass("animated");
        }
      });
    }, 120);
  },

  // Number scrolling increases
  numberScroll: function (selector, duration) {
    let num = jQuery(selector),
      targetValue = parseFloat(num.text()),
      startValue = 0,
      increment = targetValue / (duration / 10);

    let interval = setInterval(function () {
      startValue += increment;
      if (startValue >= targetValue) {
        startValue = targetValue;
        clearInterval(interval);
      }

      let decimalPlaces = targetValue % 1 === 0 ? 0 : (targetValue.toString().split(".")[1] || []).length;
      let formattedValue = startValue.toFixed(decimalPlaces);

      if (num.attr("formatted") == "true") {
        num.text(formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      } else {
        num.text(formattedValue);
      }
    }, 10);
  },

  // Header interactional
  headerMenu: function () {
    var preventTouch = function (e) {
      if (!e.target.closest || !e.target.closest('header nav')) e.preventDefault();
    };
    jQuery("body").on("click", ".menu-toggle", function () {
      jQuery(this).toggleClass("active");
      var isOpen = jQuery('header').toggleClass("menu-open").hasClass("menu-open");
      jQuery("html").toggleClass("body-hidden", isOpen);
      jQuery("body").toggleClass("body-hidden", isOpen);
      if (isOpen) {
        document.addEventListener('touchmove', preventTouch, { passive: false });
        if (typeof lenis !== 'undefined' && lenis && lenis.stop) lenis.stop();
      } else {
        document.removeEventListener('touchmove', preventTouch, { passive: false });
        if (typeof lenis !== 'undefined' && lenis && lenis.start) lenis.start();
      }
    });
  },

  // Sticky header
  headerSticky: Utils.throttle(function () {
    if (jQuery(document).scrollTop() > 60) {
      jQuery("header").addClass("sticky");
    } else {
      jQuery("header").removeClass("sticky");
    }
  }, 50),

  // Anchor link scroll effect
  anchorLink: function () {
    jQuery("body").on("click", "a", (e) => {
      if (jQuery(e.target.hash).length) {
        e.preventDefault();

        let anchorPosition = jQuery(e.target.hash).offset().top;

        Utils.pageScroll(anchorPosition, 60);
      }
    });
  },

  // Parallax
  parallax: function () {
    let sTop = jQuery(document).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = sTop + wHeight;

    jQuery(".parallax").each(function () {
      let me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.outerHeight(),
        meBottom = meTop + meHeight,
        limitTop = meTop - wHeight,
        progress = 0,
        speed = me.attr("speed") ? Number(me.attr("speed")) : 1;
      if (speed < 0) {
        speed /= 2;
      }

      if (sTop < limitTop) {
        progress = 0;
      } else if (sTop > meBottom) {
        progress = 1;
      } else {
        progress = (sTop - limitTop) / (meBottom - limitTop);
      }
      me.css("transform", "translateY(" + progress * speed * 100 + "%)");
    });

    jQuery(".parallax-inner").each(function () {
      let me = jQuery(this),
        target = me.children(),
        meTop = me.offset().top,
        meHeight = me.outerHeight(),
        meBottom = meTop + meHeight,
        limitTop = meTop - wHeight,
        progress = 0;

      if (sTop < limitTop) {
        progress = 0;
      } else if (sTop > meBottom) {
        progress = 1;
      } else {
        progress = (sTop - limitTop) / (meBottom - limitTop);
      }

      target.css("translate", "0 " + progress * 25 + "%");

    })
  },

  // Accordion
  accordion: function () {
    Utils.accordionInit(".acc-head", ".acc-body");
    Utils.accordionInit(".row-text .row .cat", ".links");
  },

  formFun: function () {
    if (jQuery('#dateField').length > 0) {
      flatpickr('#dateField', {
        dateFormat: 'j F Y',
        disableMobile: true,
        allowInput: false,
        onReady: function (selectedDates, dateStr, instance) {
          instance.input.removeAttribute('readonly');
          instance.input.setAttribute('readonly', 'readonly');
        }
      });
    }

    if (jQuery('#contactSuccess').length) {
      jQuery(window).scrollTop(0);
    }
  },

  // Sliders
  slider: function () {
    if (jQuery('.case-slider').length > 0) {
      jQuery('.case-slider').each(function () {
        jQuery(this).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: false,
          infinite: false,
          speed: 500,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            // {
            //   breakpoint: 576,
            //   settings: {
            //     slidesToShow: 1,
            //     slidesToScroll: 1,
            //   }
            // }
          ]
        });
      })
    }

    if (jQuery('.testimonial-slider').length > 0) {
      jQuery('.testimonial-slider').each(function () {
        jQuery(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          arrows: false,
          dots: false,
          autoplay: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          infinite: true,
          speed: 500,
          autoplaySpeed: 6000,
          // adaptiveHeight: true
        });
      })
    }
  },

  paramsFun: function () {
    Utils.clickParamEl("tag", ".btn", "data-tag");
  },

  hoverEffect: function () {
    jQuery('header nav a').hover(
      function () {
        jQuery(this).parents('li').siblings().addClass('inactive');
      },
      function () {
        jQuery(this).parents('li').siblings().removeClass('inactive');
      }
    )

    jQuery('.acc-item').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )

    jQuery('.row-text .row').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )

    jQuery('.gallery-grid .card-item').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )

    jQuery('.case-grid .card-item').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )

    jQuery('.all-case-grid .card-item').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )

    jQuery('.case-slider .card-item').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )

    jQuery('.marquee-item').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )

    jQuery('.products-grid .card-item').hover(
      function () {
        jQuery(this).siblings().addClass('inactive');
      },
      function () {
        jQuery(this).siblings().removeClass('inactive');
      }
    )
  },

  imgOpenPopup: function () {
    jQuery('.img-open-popup').each(function () {
      const $popup = jQuery(this);
      const $originSection = $popup.data('origin-section')
        ? jQuery($popup.data('origin-section'))
        : $popup.closest('section');
      if (!$popup.data('teleported')) {
        $popup.data('origin-section', $originSection[0]);
        $popup.appendTo(document.body).data('teleported', true);
      }
      const $items = $popup.find('.img-open-slider .item');
      const total = $items.length;
      const closeBtn = $popup.find('.btn-close');
      if (!total) return;

      const $prevBtn = $popup.find('.btn-previous');
      const $nextBtn = $popup.find('.btn-next');

      const showItem = function (index) {
        const n = ((index % total) + total) % total;
        $items.removeClass('active').eq(n).addClass('active');
      };

      const currentIndex = function () {
        const i = $items.index($items.filter('.active'));
        return i < 0 ? 0 : i;
      };

      $prevBtn.on('click', function () { showItem(currentIndex() - 1); });
      $nextBtn.on('click', function () { showItem(currentIndex() + 1); });

      $popup.find('.btn-previous, .btn-next').each(function () {
        const $btn = jQuery(this);
        const $label = $btn.find('i');
        $btn.on('mousemove', function (e) {
          const rect = this.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          $label.css('transform', 'translate3d(' + x + 'px, ' + y + 'px, 0) translate(-50%, -50%)');
        });
      });

      const $slider = $popup.find('.img-open-slider');
      let startX = 0, startY = 0, dragging = false;
      const threshold = 40;

      $slider.on('pointerdown', function (e) {
        dragging = true;
        startX = e.clientX;
        startY = e.clientY;
        try { this.setPointerCapture(e.pointerId); } catch (err) { }
      });

      $slider.on('pointerup pointercancel', function (e) {
        if (!dragging) return;
        dragging = false;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
          showItem(currentIndex() + (dx > 0 ? -1 : 1));
        }
      });

      const $section = $originSection;
      const $cards = $section.find('.grid-container .card-item').filter(function () {
        return jQuery(this).find('.img-box').length > 0;
      });

      $cards.on('click', function () {
        const i = $cards.index(this);
        if (i < 0 || i >= total) return;
        showItem(i);
        $popup.addClass('active');
        jQuery('body').addClass('body-hidden');
        if (typeof lenis !== 'undefined' && lenis && typeof lenis.stop === 'function') lenis.stop();
      });

      closeBtn.on('click', function () {
        $popup.removeClass('active');
        jQuery('body').removeClass('body-hidden');
        if (typeof lenis !== 'undefined' && lenis && typeof lenis.start === 'function') lenis.start();
      });

      jQuery(document).on('keydown.imgOpenPopup', function (e) {
        if (!$popup.hasClass('active')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); showItem(currentIndex() - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); showItem(currentIndex() + 1); }
        else if (e.key === 'Escape') {
          $popup.removeClass('active');
          jQuery('body').removeClass('body-hidden');
          if (typeof lenis !== 'undefined' && lenis && typeof lenis.start === 'function') lenis.start();
        }
      });
    });
  },

  loadMore: function () {
    jQuery('.all-case-grid').each(function () {
      const $section = jQuery(this);
      const $grid = $section.find('.grid-container');
      const $cards = $grid.find('.card-item');
      const $btn = $section.find('.btn-row .btn');

      if ($cards.length > 48) {
        $grid.addClass('has-more');
      } else {
        $grid.removeClass('has-more');
      }

      $btn.on('click', function (e) {
        e.preventDefault();
        $grid.removeClass('has-more');
      });
    });
  },
};

jQuery(document).ready(function () {
  customMethods.run();
});

jQuery(window).scroll(function () {
  customMethods.wowo();
  customMethods.headerSticky();
  customMethods.parallax();
});

function setFooterHeightVar() {
  var $f = jQuery('footer').first();
  if (!$f.length) return;
  document.body.style.setProperty('--height-footer-', $f.outerHeight() + 'px');
}

jQuery(setFooterHeightVar);
jQuery(window).resize(function () {
  customMethods.appHeight();
  setFooterHeightVar();
});

jQuery(function () {
  var $pre = jQuery('.preload-screen');
  if (!$pre.length) return;
  if (sessionStorage.getItem('lbp_preloaded')) {
    $pre.addClass('is-hiding');
    return;
  }
  sessionStorage.setItem('lbp_preloaded', '1');
  $pre.addClass('is-active');
  var savedY = window.scrollY || window.pageYOffset || 0;
  jQuery('html, body').addClass('body-hidden');
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + savedY + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  if (typeof lenis !== 'undefined' && lenis && lenis.stop) lenis.stop();
  var unlocked = false;
  var unlock = function () {
    if (unlocked) return; unlocked = true;
    jQuery('html, body').removeClass('body-hidden');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedY);
    if (typeof lenis !== 'undefined' && lenis && lenis.start) lenis.start();
  };
  var hide = function () { $pre.addClass('is-hiding'); unlock(); };
  var t = setTimeout(hide, 5000);
  $pre.on('click', function () { clearTimeout(t); hide(); });
});

function setMarqueeImgWidth(img) {
  var originalWidth = img.naturalWidth;
  if (!originalWidth) return false;
  var newWidth = originalWidth / 2;
  jQuery(img).parent().attr('style', '--img-width-:' + newWidth + 'px;');
  return true;
}

function refreshMarqueeImgWidths() {
  var anyMissing = false;
  jQuery('.marquee-item img').each(function () {
    var $p = jQuery(this).parent();
    var cur = parseFloat(($p.attr('style') || '').match(/--img-width-:\s*([\d.]+)/) ? RegExp.$1 : '0');
    if (cur > 0) return;
    if (!setMarqueeImgWidth(this)) anyMissing = true;
  });
  return !anyMissing;
}

var marqueeInitDone = false;
function initMarquee() {
  if (marqueeInitDone) return;
  if (!jQuery('.marquee-track').length) return;
  // require all img widths to be set
  var allReady = true;
  jQuery('.marquee-item img').each(function () {
    var $p = jQuery(this).parent();
    var cur = parseFloat(($p.attr('style') || '').match(/--img-width-:\s*([\d.]+)/) ? RegExp.$1 : '0');
    if (!cur) allReady = false;
  });
  if (!allReady) return;
  jQuery('.marquee-track').each(function () {
    var speed = 42;
    var rowWidth = jQuery(this).children('.marquee-row').first().outerWidth(true);
    if (!rowWidth) { allReady = false; return; }
    var duration = rowWidth / speed;
    this.style.setProperty('--brands-duration', duration + 's');
  });
  if (!allReady) return;
  jQuery('.marquee-track').each(function () {
    var $t = jQuery(this);
    if ($t.hasClass('play')) return;
    var marqueeWidth = $t.outerWidth(true);
    var bodyWidth = $t.parents('section').outerWidth(true);
    if (marqueeWidth > bodyWidth) {
      $t.append($t.html());
      $t.addClass('play');
    } else {
      $t.removeClass('play');
    }
  });
  marqueeInitDone = true;
}

jQuery(window).on('load', function () {
  jQuery('.marquee-item img').each(function () {
    var img = this;
    if (!setMarqueeImgWidth(img)) {
      jQuery(img).one('load', function () { setMarqueeImgWidth(img); initMarquee(); });
    }
  });
  initMarquee();
});

(function () {
  function check() {
    if (marqueeInitDone) return;
    if (!jQuery('.marquee-item img').length) return;
    refreshMarqueeImgWidths();
    initMarquee();
  }
  jQuery(window).on('scroll resize', check);
  document.addEventListener('scroll', check, { passive: true, capture: true });
})();